import clsx from "clsx";
import { createPluggable } from "pluggable-react";
import Overlay from "../Overlay/Overlay";
import LoadingStatus from "../LoadingStatus/LoadingStatus";
import Status from "../Status/Status";
import styles from "./LoadingOverlay.module.scss";

export interface LoadingOverlayProps extends React.HTMLAttributes<HTMLDivElement> {
    className?: string;
    message?: string;
    children?: React.ReactNode;
}

const DefaultLoadingOverlay = (props: LoadingOverlayProps) => {
    const { className, message, children, ...rest } = props;

    return (
        <Overlay className={clsx(styles.loadingOverlay, className)} {...rest}>
            <LoadingStatus message={message}>
                {children}
            </LoadingStatus>
        </Overlay>
    );
};

const LoadingOverlay = createPluggable<LoadingOverlayProps>("deci.loadingOverlay", DefaultLoadingOverlay);

export default Object.assign(LoadingOverlay, {
    Graphic: Status.Graphic,
    Title: Status.Title,
    Content: Status.Content,
});
